export { useUserInfo, UserInfoProvider, AuthWrapper, usePermission } from './useUserInfo';
export { useWindowFocus, usePageVisibility } from './useWindowFocus';

import { useLocation, useNavigate } from 'react-router-dom';
export const useRouter = (): any => {
  const navigate = useNavigate();
  return {
    replace: (path: string) => {
      navigate(path, { replace: true });
    },
    push: (path: string) => {
      navigate(path);
    },
    goBack: () => {
      navigate(-1);
    },
    goForward: () => {
      navigate(1);
    },
    go: (n: number) => {
      navigate(n);
    },
    navigate
  };
};

export const usePathname = (): string => {
  const location = useLocation();
  return location.pathname;
};

export const useSearchParams = (): { [key: string]: string } => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  // 将 URLSearchParams 转换为对象
  const queryObject = Object.fromEntries(searchParams.entries());

  return queryObject;
};
